import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router';

import { request } from '@/shared/api';
import { paths } from '@/shared/config';
import { Button } from '@/shared/ui/button';

export function SignOutButton() {
  const client = useQueryClient();
  const navigate = useNavigate();
  const signOut = useMutation({
    mutationFn: () => request('POST', '/session/logout'),
    onSettled: async () => {
      // Nothing of the previous user may stay in the cache.
      client.clear();
      await navigate(paths.login, { replace: true });
    },
  });
  return (
    <Button variant="secondary" loading={signOut.isPending} onClick={() => signOut.mutate()}>
      Выйти
    </Button>
  );
}
